
import projectsAPI from './projects';
import focalPeopleAPI from './focal_people';
import locationsAPI from './locations';
import sectorAPI from  './sectors';
import subProjectsAPI from  './sub_projects';
import agenciesAPI from './agencies';
import moneyAPI from './money';
import subProjectElementsAPI from  './sub_project_elements';
import environmentalCategoriesAPI from  './environmental_categories';
import itemsAPI from './items';
import progressAPI from './progress'
import wfsRequests from  './wfs_requests';
import usersAPI from './users';
import contracsAPI from './contracts';
import geonodeAPI from './geonode';
import kobotoolboxAPI from './kobotoolbox';
import subProjectSurveyAPI from './sub_project_survey';
import ticketsAPI from './tickets';
import procuringEntityAPI from './procuring_entities';
import procuringEntityContractAPI from './procuring_entity_contracts';
import procuringEntityPackageContractAPI from './procuring_entity_package_contracts';
import contractorsAPI from './contractors';
import procuringEntityProgressReportsAPI from './procuring_entities_progress_reports';
import safeguardCconcersAPI from './safeguard_concers';
import unitAPI from './unit'
import packages from './packages';
import apiUtilities from './utilities';
import councils from "./councils";
import documents from "./document";
import generalRecommendations from "./general-recommendations";
import trpImplementations from "./trp_implementation";
import challenges from "./challenges";
import reports from "./reports";
import projectOnboardingAPI from "./project-onboarding";
import auditLogsAPI from "./audit-logs";
import passwordManagementAPI from "./password-management";
import alertsAPI from "./alerts";
import reportCommentsAPI from "./report-comments";

export default {
  ...projectsAPI,
  ...focalPeopleAPI,
  ...locationsAPI,
  ...sectorAPI,
  ...moneyAPI,
  ...subProjectsAPI,
  ...agenciesAPI,
  ...subProjectElementsAPI,
  ...environmentalCategoriesAPI,
  ...wfsRequests,
  ...itemsAPI,
  ...progressAPI,
  ...usersAPI,
  ...contracsAPI,
  ...geonodeAPI,
  ...kobotoolboxAPI,
  ...subProjectSurveyAPI,
  ...ticketsAPI,
  ...procuringEntityAPI,
  ...procuringEntityContractAPI,
  ...procuringEntityPackageContractAPI,
  ...contractorsAPI,
  ...unitAPI,
  ...procuringEntityProgressReportsAPI,
  ...safeguardCconcersAPI,
  ...packages,
  ...apiUtilities,
  ...councils,
  ...documents,
  ...generalRecommendations,
  ...trpImplementations,
  ...challenges,
  ...reports,
  ...projectOnboardingAPI,
  ...auditLogsAPI,
  ...passwordManagementAPI,
  ...alertsAPI,
  ...reportCommentsAPI,
};
